export const hasHorarioOcupadoNoPeriodo = (
  horarioInicial: Date | undefined,
  horarioFinal: Date | undefined,
  horariosAgenda: ReadonlyArray<{ horario: Date; isOcupado: boolean; isReservadoAgendaOnline: boolean }> | undefined,
  verificarReservasAgendaOnline: boolean
): boolean => {
  if (!horarioInicial || !horarioFinal || !horariosAgenda) {
    return false
  }

  return horariosAgenda.some(({ horario, isOcupado, isReservadoAgendaOnline }) => {
    const isHorarioDentroDoPeriodo = Number(horario) >= Number(horarioInicial) && Number(horario) < Number(horarioFinal)
    const isHorarioReservadoAgendaOnline = verificarReservasAgendaOnline && isReservadoAgendaOnline
    const isHorarioOcupado = isOcupado || isHorarioReservadoAgendaOnline

    return isHorarioDentroDoPeriodo && isHorarioOcupado
  })
}
